document.querySelectorAll('.wp-block-sba-newsletter__form').forEach((form) => {
    const message = form.querySelector('.wp-block-sba-newsletter__message');
    const submit = form.querySelector('.wp-block-sba-newsletter__submit');

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const email = form.querySelector('input[name="email"]').value.trim();
        if (!email) return;

        submit.disabled = true;
        message.hidden = true;
        message.className = 'wp-block-sba-newsletter__message';

        try {
            const res = await fetch(form.dataset.endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            const data = await res.json();

            message.textContent = data.message;
            message.classList.add(data.success || data.already_subscribed ? 'is-success' : 'is-error');
            message.hidden = false;

            if (data.success) form.reset();
        } catch {
            message.textContent = 'Une erreur est survenue. Veuillez réessayer.';
            message.classList.add('is-error');
            message.hidden = false;
        } finally {
            submit.disabled = false;
        }
    });
});
